import React from 'react';
import PropTypes from 'prop-types';
import Button from "../Button/Button";
import SuccessIcon from "../Icons/SuccessIcon";
import ErrorIcon from "../Icons/ErrorIcon";

const StepOne = ({ popupData, popupHandler, currentStep, eacValue, inputEACHandler, inputEACSuffixHandler, stepTwoStatus, eacValueSuffix, validateEac, eacInputHasError, eacInputSuffixHasError }) => {

  return (
    <div className={"eac-check__step"}>
      <div className="eac-check__step__title">
        Шаг 2
        {stepTwoStatus === "fail"
          ? <ErrorIcon />
          : stepTwoStatus === "success"
            ? <SuccessIcon />
            : null}
      </div>
      <div className="eac-check__step__subtitle">
        Укажите номер модели и&nbsp;суффикс,<br/> чтобы начать проверку
      </div>

      <div className="eac-check__content between">
        <div className={"eac__form-group"}>
          <input type="text"
                 placeholder="Введите номер модели"
                 onInput={inputEACHandler}
                 className={eacInputHasError ? "has-error" : ""}
                 disabled={!currentStep} />
        </div>

        <div className={"eac__form-group"}>
          <input type="text"
                 placeholder="Введите суффикс"
                 className={eacInputSuffixHasError ? "has-error" : ""}
                 onInput={inputEACSuffixHandler}
                 disabled={!currentStep} />
        </div>

      </div>

      <div className="eac-check__buttons">

        <Button className={"function__button full__button"}
                text={"Отправить"}
                onClick={validateEac} />

      </div>
    </div>
  );

};

StepOne.propTypes = {};

export default StepOne;
